import { render, staticRenderFns } from "./ImageSection.vue?vue&type=template&id=61975d8a&scoped=true&lang=pug&"
import script from "./ImageSection.vue?vue&type=script&lang=js&"
export * from "./ImageSection.vue?vue&type=script&lang=js&"
import style0 from "./ImageSection.vue?vue&type=style&index=0&id=61975d8a&lang=sass&nolang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61975d8a",
  null
  
)

export default component.exports